var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-user-roles',{ref:"table",staticClass:"pt-user-roles__withData",on:{"rolesDelete":_vm.rolesDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }